/**
 * Sort utilities to display NEW/PENDING items at the top
 * and COMPLETED/CANCELLED/REPLIED items at the bottom.
 *
 * Priority lower = closer to the top.
 * Within the same priority we sort by created_at desc (newest first).
 */

const STATUS_PRIORITY = {
  // PENDING / NEW (top)
  unread: 0,
  pending: 0,
  new: 0,
  draft: 0,
  // ACTIVE / IN PROGRESS
  read: 1,
  confirmed: 1,
  sent: 1,
  in_progress: 1,
  validated: 1,
  quote_sent: 1,
  // PAID / RESOLVED (still recent but no action required)
  unpaid: 2,
  accepted: 2,
  // DONE (bottom)
  paid: 8,
  delivered: 8,
  completed: 8,
  replied: 8,
  // CANCELLED / REFUSED (bottom-most)
  cancelled: 9,
  refused: 9,
  rejected: 9,
  expired: 9,
};

const getStatusPriority = (item) => {
  const s = (item?.status || '').toLowerCase();
  if (s in STATUS_PRIORITY) return STATUS_PRIORITY[s];
  // Contact messages : if there is a reply, treat as done
  if (Array.isArray(item?.replies) && item.replies.length > 0) return 8;
  // Default: middle priority
  return 5;
};

const dateValue = (item) => {
  const d = item?.created_at || item?.date || item?.updated_at || '';
  if (!d) return 0;
  const t = new Date(d).getTime();
  return isNaN(t) ? 0 : t;
};

/**
 * Sort an array of records (appointments, invoices, etc.) so:
 *  - new/pending items are first
 *  - within the same priority, newest first (by created_at desc)
 *  - completed/cancelled items are pushed to the bottom
 */
export const sortByTreatment = (arr) => {
  if (!Array.isArray(arr)) return arr;
  return [...arr].sort((a, b) => {
    const pa = getStatusPriority(a);
    const pb = getStatusPriority(b);
    if (pa !== pb) return pa - pb;
    return dateValue(b) - dateValue(a);
  });
};

export { getStatusPriority };
